// document.addEventListener('DOMContentLoaded', function () {
//   if (!document.querySelector('#FlipbenchBundleSelect')) return;

//   initFlipbenchBundleUI(document);
//   forceFlipbenchButtonStatus();
// });
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('#FlipbenchBundleSelect')) return;

  initFlipbenchBundleUI(document);
  forceFlipbenchButtonStatus();

  /*
   * Set the Stamped Main Widget product ID.
   * Retries are required because the Stamped app script loads asynchronously.
   */
  syncFlipbenchStampedMainWidget(true);

  setTimeout(function () {
    syncFlipbenchStampedMainWidget(true);
  }, 500);

  setTimeout(function () {
    syncFlipbenchStampedMainWidget(true);
  }, 1500);

  setTimeout(function () {
    syncFlipbenchStampedMainWidget(true);
  }, 3000);
});

if (!document.querySelector('#FlipbenchBundleSelect')) {
  // Not a Flipbench bundle page. Do not run this script.
} else {
  window.flipbenchIsPreorder = false;
  window.flipbenchIsAvailable = true;
}

window.flipbenchIsPreorder = false;
window.flipbenchIsAvailable = true;

/* ================================
   MAIN INIT
================================ */
function initFlipbenchBundleUI(scope) {
  scope = scope || document;

  var bundleSelect    = scope.querySelector('#FlipbenchBundleSelect');
  var wheelKitCheckbox = scope.querySelector('#FlipbenchWheelKitCheckbox');
  var wheelKitQtyWrap  = scope.querySelector('#FlipbenchWheelKitQtyWrap');
  var wheelKitQty      = scope.querySelector('#FlipbenchWheelKitQty');
  var wheelMinus       = scope.querySelector('.flipbench-wheelkit-minus');
  var wheelPlus        = scope.querySelector('.flipbench-wheelkit-plus');

  if (bundleSelect && bundleSelect.dataset.flipbenchBound !== 'true') {
    bundleSelect.dataset.flipbenchBound = 'true';

    bundleSelect.addEventListener('change', function () {
      var selectedOption = this.options[this.selectedIndex];
      if (!selectedOption) return;

      updateFlipbenchStateFromOption(selectedOption);
      syncFlipbenchButtonVisibility();

      var url             = selectedOption.getAttribute('data-product-url');
      var selectedVariantId = selectedOption.value;

      if (!url) return;

      // Read directly from option attributes + DOM — never trust window.flipbenchIsPreorder
      // here as it can carry stale state from forceFlipbenchButtonStatus timeouts.
      var hasPreorderTag  = selectedOption.getAttribute('data-has-preorder') === 'true';
      var isAvailable     = selectedOption.getAttribute('data-product-available') === 'true';
      var optQty          = parseInt(selectedOption.getAttribute('data-inventory-qty') || '0', 10);
      var optPolicy       = selectedOption.getAttribute('data-inventory-policy') || 'deny';
      var optOversell     = optPolicy === 'continue';
      var isPreorder      = hasPreorderTag || !isAvailable || (!optOversell && optQty <= 0) || flipbenchDetectOutOfStockFromDOM();

      if (isPreorder) {
        // Full redirect so the pre-order app's JS runs natively on the target page
        window.location.href = url;
        return;
      }

      swapFlipbenchBundleContent(url, selectedVariantId);
    });
  }

  if (wheelKitCheckbox && wheelKitQtyWrap && wheelKitCheckbox.dataset.flipbenchBound !== 'true') {
    wheelKitCheckbox.dataset.flipbenchBound = 'true';

    function toggleWheelKitQty() {
      if (wheelKitCheckbox.checked) {
        wheelKitQtyWrap.style.display = 'block';
      } else {
        wheelKitQtyWrap.style.display = 'none';
        if (wheelKitQty) wheelKitQty.value = 1;
      }
    }

    wheelKitCheckbox.addEventListener('change', toggleWheelKitQty);
    toggleWheelKitQty();
  }

  if (wheelMinus && wheelKitQty && wheelMinus.dataset.flipbenchBound !== 'true') {
    wheelMinus.dataset.flipbenchBound = 'true';
    wheelMinus.addEventListener('click', function () {
      wheelKitQty.value = Math.max(1, parseInt(wheelKitQty.value || '1', 10) - 1);
    });
  }

  if (wheelPlus && wheelKitQty && wheelPlus.dataset.flipbenchBound !== 'true') {
    wheelPlus.dataset.flipbenchBound = 'true';
    wheelPlus.addEventListener('click', function () {
      wheelKitQty.value = parseInt(wheelKitQty.value || '1', 10) + 1;
    });
  }
}

/* ================================
   GLOBAL BUTTON CAPTURE
   Handles Add to Cart + Pre-order
================================ */
document.addEventListener(
  'submit',
  function (e) {
    var form = e.target;

    var isNormalProductForm =
      form.closest('#FlipbenchProductForm') ||
      form.matches('form[action*="/cart/add"]');

    var isPreorderForm =
      document.body.classList.contains('flipbench-is-preorder') &&
      (
        form.matches('form[id^="product-form-template"]') ||
        form.innerHTML.toLowerCase().indexOf('pre-order') !== -1 ||
        form.innerHTML.toLowerCase().indexOf('preorder') !== -1
      );

    if (!isNormalProductForm && !isPreorderForm) return;

    e.preventDefault();
    e.stopPropagation();

    addFlipbenchBundleToCart();
  },
  true
);

document.addEventListener(
  'click',
  function (e) {
    var preorderMode = document.body.classList.contains('flipbench-is-preorder');
    if (!preorderMode) return;

    var btn = e.target.closest('button, input[type="submit"], [role="button"], a');
    if (!btn) return;

    var text = (btn.textContent || btn.value || '').toLowerCase();
    var cls  = (btn.className || '').toString().toLowerCase();
    var id   = (btn.id || '').toLowerCase();

    var isPreorderButton =
      text.indexOf('pre-order') !== -1 ||
      text.indexOf('preorder')  !== -1 ||
      cls.indexOf('preorder')   !== -1 ||
      id.indexOf('preorder')    !== -1;

    if (!isPreorderButton) return;

    e.preventDefault();
    e.stopPropagation();

    addFlipbenchBundleToCart();
  },
  true
);

/* ================================
   ADD MAIN PRODUCT + WHEEL KIT
================================ */
function addFlipbenchBundleToCart() {
  var bundleSelect     = document.querySelector('#FlipbenchBundleSelect');
  var wheelKitCheckbox = document.querySelector('#FlipbenchWheelKitCheckbox');
  var wheelKitQty      = document.querySelector('#FlipbenchWheelKitQty');

  if (!bundleSelect) return;

  var selectedOption = bundleSelect.options[bundleSelect.selectedIndex];
  if (!selectedOption) return;

  var mainVariantId = parseInt(selectedOption.value || '0', 10);
  if (!mainVariantId) return;

  var mainQtyInput = document.querySelector('#quantity, input[name="quantity"]');
  var mainQty      = mainQtyInput ? parseInt(mainQtyInput.value || '1', 10) : 1;

  var items = [{ id: mainVariantId, quantity: mainQty }];

  if (wheelKitCheckbox && wheelKitCheckbox.checked) {
    var wheelVariantId = parseInt(wheelKitCheckbox.value || '0', 10);
    var qty = wheelKitQty ? parseInt(wheelKitQty.value || '1', 10) : 1;

    if (wheelVariantId && qty > 0) {
      items.push({ id: wheelVariantId, quantity: qty });
    }
  }

  var addBtn  = document.querySelector('#FlipbenchAddToCartButton');
  var addText = document.querySelector('#FlipbenchAddToCartText');

  if (addBtn)  addBtn.disabled = true;
  if (addText) addText.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) { throw err; });
      }
      return res.json();
    })
    .then(function () {
      window.location.href = '/cart';
    })
    .catch(function (err) {
      console.error('Flipbench bundle add error:', err);
      if (addBtn)  addBtn.disabled = false;
      if (addText) addText.textContent = 'Add to cart';
      alert('There was a problem adding this bundle to cart.');
    });
}

/* ================================
   PRODUCT SWAP
================================ */
function swapFlipbenchBundleContent(url, selectedVariantId) {
  showFlipbenchLoader();

  var currentImagesWrap        = document.querySelector('.product__images');
  var currentProductRoot       = document.querySelector('.product-main');
  var currentProductFormWrap   = document.querySelector('#FlipbenchProductForm');
  var currentReferencePriceWrap = document.querySelector('#FlipbenchReferencePriceNoteWrap');
  var currentPaymentTermsWrap  = document.querySelector('#FlipbenchPaymentTermsWrap');
  var currentTitleEl           = document.querySelector('#FlipbenchDynamicTitle');
  var currentTopPriceCurrent   = document.querySelector('.flipbench-top-price__current');
  var currentTopPriceSave      = document.querySelector('.flipbench-top-price__save');
  var currentReviewsWrap       = document.querySelector('#FlipbenchReviewsWrap');
  var currentDescriptionWrap   = document.querySelector('#FlipbenchDescriptionWrap');

  if (!currentImagesWrap || !currentProductRoot) {
    hideFlipbenchLoader();
    window.location.href = url;
    return;
  }

  var currentProductClass = Array.from(currentProductRoot.classList).find(function (cls) {
    return cls.indexOf('product-') === 0 && cls !== 'product-main';
  });

  currentImagesWrap.style.opacity      = '0.5';
  currentImagesWrap.style.pointerEvents = 'none';

  fetch(url, {
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Failed to load product page');
      return res.text();
    })
    .then(function (htmlText) {
      var parser = new DOMParser();
      var doc    = parser.parseFromString(htmlText, 'text/html');

      var newImagesWrap            = doc.querySelector('.product__images');
      var fetchedProductFormWrap   = doc.querySelector('#FlipbenchProductForm');
      var fetchedReferencePriceWrap = doc.querySelector('#FlipbenchReferencePriceNoteWrap');
      var fetchedPaymentTermsWrap  = doc.querySelector('#FlipbenchPaymentTermsWrap');
      var fetchedTitleEl           = doc.querySelector('#FlipbenchDynamicTitle');
      var fetchedTopPriceCurrent   = doc.querySelector('.flipbench-top-price__current');
      var fetchedTopPriceSave      = doc.querySelector('.flipbench-top-price__save');
      var fetchedReviewsWrap       = doc.querySelector('#FlipbenchReviewsWrap');
      var fetchedDescriptionWrap   = doc.querySelector('#FlipbenchDescriptionWrap');
      var newProductRoot           = doc.querySelector('.product-main');

      var newProductClass = newProductRoot
        ? Array.from(newProductRoot.classList).find(function (cls) {
            return cls.indexOf('product-') === 0 && cls !== 'product-main';
          })
        : null;

      if (!newImagesWrap) throw new Error('New gallery not found');

      // Destroy old Flickity instances before replacing HTML
      try {
        var $oldGallery = window.jQuery ? window.jQuery('.js-product-gallery') : null;
        var $oldThumbs  = window.jQuery ? window.jQuery('.product_gallery_nav') : null;

        if ($oldThumbs && $oldThumbs.length && $oldThumbs.hasClass('flickity-enabled')) {
          $oldThumbs.flickity('destroy');
        }
        if ($oldGallery && $oldGallery.length && $oldGallery.hasClass('flickity-enabled')) {
          $oldGallery.flickity('destroy');
        }
      } catch (e) {}

      // ── Swap gallery ──
      currentImagesWrap.innerHTML = newImagesWrap.innerHTML;
      hydrateFlipbenchImages(currentImagesWrap);

      // ── Swap title ──
      if (currentTitleEl && fetchedTitleEl) currentTitleEl.innerHTML = fetchedTitleEl.innerHTML;

      // ── Swap price ──
      if (currentTopPriceCurrent && fetchedTopPriceCurrent) {
        currentTopPriceCurrent.innerHTML = fetchedTopPriceCurrent.innerHTML;
      }
      if (currentTopPriceSave) {
        if (fetchedTopPriceSave) {
          currentTopPriceSave.innerHTML = fetchedTopPriceSave.innerHTML;
          if (fetchedTopPriceSave.getAttribute('style')) {
            currentTopPriceSave.setAttribute('style', fetchedTopPriceSave.getAttribute('style'));
          } else {
            currentTopPriceSave.removeAttribute('style');
          }
        } else {
          currentTopPriceSave.innerHTML    = '';
          currentTopPriceSave.style.display = 'none';
        }
      }

      // ── Swap reviews badge ──
      // if (currentReviewsWrap) {
      //   currentReviewsWrap.innerHTML = fetchedReviewsWrap ? fetchedReviewsWrap.innerHTML : '';
      // }
      // ── Swap reviews badge and mapped review-source ID ──
      if (currentReviewsWrap) {
        if (fetchedReviewsWrap) {
          currentReviewsWrap.innerHTML =
            fetchedReviewsWrap.innerHTML;

          var fetchedReviewSourceId =
            fetchedReviewsWrap.getAttribute(
              'data-stamped-review-source-id'
            );

          if (fetchedReviewSourceId) {
            currentReviewsWrap.setAttribute(
              'data-stamped-review-source-id',
              fetchedReviewSourceId
            );
          } else {
            currentReviewsWrap.removeAttribute(
              'data-stamped-review-source-id'
            );
          }
        } else {
          currentReviewsWrap.innerHTML = '';

          currentReviewsWrap.removeAttribute(
            'data-stamped-review-source-id'
          );
        }
      }

      // ── FIX: Update Stamped main widget attributes from fetched page ──
      // The badge inside #FlipbenchReviewsWrap is already swapped above.
      // The main reviews listing widget needs its data-product-id updated too,
      // otherwise reloadUGC() will re-render the wrong product's reviews.
      var stampedSelectors = [
        '#stamped-main-widget',
        '[data-widget-type="main"]',
        '[data-stamped-widget-type="main"]',
        '.stamped-reviews-widget'
      ];

      function findStampedWidget(root) {
        for (var si = 0; si < stampedSelectors.length; si++) {
          var el = root.querySelector(stampedSelectors[si]);
          if (el) return el;
        }
        return null;
      }

      var currentStampedWidget = findStampedWidget(document);
      var fetchedStampedWidget  = findStampedWidget(doc);

      if (currentStampedWidget && fetchedStampedWidget) {
        // Copy every attribute from the fetched widget onto the live one
        var fetchedAttrs = fetchedStampedWidget.attributes;
        for (var ai = 0; ai < fetchedAttrs.length; ai++) {
          currentStampedWidget.setAttribute(fetchedAttrs[ai].name, fetchedAttrs[ai].value);
        }
        // Clear rendered content so Stamped does a full clean re-render
        currentStampedWidget.innerHTML = '';
      } else if (currentStampedWidget) {
        // Fallback: pull product data from the already-swapped badge
        var swappedBadge = document.querySelector('#FlipbenchReviewsWrap .stamped-product-reviews-badge');
        if (swappedBadge) {
          currentStampedWidget.setAttribute('data-product-id',    swappedBadge.getAttribute('data-id') || '');
          currentStampedWidget.setAttribute('data-product-title', swappedBadge.getAttribute('data-product-title') || '');
          currentStampedWidget.setAttribute('data-product-type',  swappedBadge.getAttribute('data-product-type') || '');
          currentStampedWidget.innerHTML = '';
        }
      }

      /*
       * Apply the mapped review-source ID after the fetched
       * Stamped attributes have been copied.
       */
      syncFlipbenchStampedMainWidget(false);

      // ── Swap description ──
      if (currentDescriptionWrap) {
        if (fetchedDescriptionWrap) {
          currentDescriptionWrap.innerHTML  = fetchedDescriptionWrap.innerHTML;
          currentDescriptionWrap.className  = fetchedDescriptionWrap.className;
          if (fetchedDescriptionWrap.getAttribute('style')) {
            currentDescriptionWrap.setAttribute('style', fetchedDescriptionWrap.getAttribute('style'));
          } else {
            currentDescriptionWrap.removeAttribute('style');
          }
        } else {
          currentDescriptionWrap.innerHTML = '';
          currentDescriptionWrap.removeAttribute('style');
        }
      }

      // ── Swap product form ──
      if (currentProductFormWrap && fetchedProductFormWrap) {
        currentProductFormWrap.outerHTML = fetchedProductFormWrap.outerHTML;
      }

      // ── Swap reference price note ──
      if (currentReferencePriceWrap) {
        currentReferencePriceWrap.innerHTML = fetchedReferencePriceWrap
          ? fetchedReferencePriceWrap.innerHTML
          : '';
      }

      // ── Swap payment terms ──
      if (currentPaymentTermsWrap) {
        currentPaymentTermsWrap.innerHTML = fetchedPaymentTermsWrap
          ? fetchedPaymentTermsWrap.innerHTML
          : '<form class="payment-terms-container flipbench-payment-terms" data-payment-terms-target style="display: none;"></form>';
      }

      // ── Swap product class on root ──
      if (currentProductClass && newProductClass && currentProductRoot.classList.contains(currentProductClass)) {
        currentProductRoot.classList.remove(currentProductClass);
        currentProductRoot.classList.add(newProductClass);
      }

      currentImagesWrap.style.opacity      = '';
      currentImagesWrap.style.pointerEvents = '';

      setTimeout(function () {
        // Sync hidden variant select
        var newVariantSelect = document.querySelector('#FlipbenchDynamicVariantId');
        if (newVariantSelect && selectedVariantId) {
          newVariantSelect.value = selectedVariantId;
          newVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Re-read bundle select state
        var liveBundleSelect = document.querySelector('#FlipbenchBundleSelect');
        if (liveBundleSelect) {
          var selectedOption = liveBundleSelect.options[liveBundleSelect.selectedIndex];
          if (selectedOption) updateFlipbenchStateFromOption(selectedOption);
        }

        // Re-init Flickity gallery
        try {
          var $gallery = window.jQuery ? window.jQuery('.js-product-gallery') : null;
          if ($gallery && $gallery.length && window.productPage && typeof window.productPage.enableGallery === 'function') {
            window.productPage.enableGallery($gallery);
          }
        } catch (e) {}

        // FIX: Re-init Stamped with all available methods so the new product's
        // reviews fully render. reloadUGC() alone does not re-render the widget
        // if attributes haven't been recognised — init() forces a full re-render.
        // if (window.StampedFn) {
        //   try {
        //     if (typeof window.StampedFn.init === 'function')       window.StampedFn.init();
        //     if (typeof window.StampedFn.reloadUGC === 'function')  window.StampedFn.reloadUGC();
        //     if (typeof window.StampedFn.loadBadges === 'function') window.StampedFn.loadBadges();
        //   } catch (e) {
        //     console.warn('Stamped reinit error:', e);
        //   }
        // }
        /*
        * Reload the rating badge and complete Stamped Main Widget
        * using the mapped review-source product ID.
        */
        syncFlipbenchStampedMainWidget(true);

        // Re-init Shopify payment button
        if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
          try { Shopify.PaymentButton.init(); } catch (e) {}
        }
        // ↓↓↓ ADD THESE LINES ↓↓↓
        syncFlipbenchPaymentTerms();
        // safety retry in case the payment-terms script hydrates a beat late
        setTimeout(syncFlipbenchPaymentTerms, 300);
        // ↑↑↑ ADD THESE LINES ↑↑↑

        initFlipbenchBundleUI(document);
        forceFlipbenchButtonStatus();
      }, 180);

      window.history.replaceState({}, '', url);
      hideFlipbenchLoader();
    })
    .catch(function (error) {
      hideFlipbenchLoader();
      console.error('Bundle swap error:', error);
      window.location.href = url;
    });
}

/* ================================
   HELPERS
================================ */

// Preorder detection uses THREE layers:
// 1. Option attributes  — data-has-preorder, data-product-available, qty + policy
// 2. DOM fallback       — theme's own button showing "Sold Out" / disabled
// 3. Preorder app probe — the app's form already has a pre-order button rendered
// Using all three catches out-of-stock even when Liquid attributes are stale/wrong.
function updateFlipbenchStateFromOption(option) {
  var available       = option.getAttribute('data-product-available') === 'true';
  var hasPreorder     = option.getAttribute('data-has-preorder') === 'true';
  var qty             = parseInt(option.getAttribute('data-inventory-qty') || '0', 10);
  var inventoryPolicy = option.getAttribute('data-inventory-policy') || 'deny';
  var oversellAllowed = inventoryPolicy === 'continue';

  var attributeSaysPreorder = hasPreorder || !available || (!oversellAllowed && qty <= 0);
  var domSaysPreorder       = flipbenchDetectOutOfStockFromDOM();

  window.flipbenchIsAvailable = available;
  window.flipbenchIsPreorder  = attributeSaysPreorder || domSaysPreorder;
}

// Inspect live page DOM for sold-out / preorder signals,
// independent of what Liquid rendered into the option attributes.
function flipbenchDetectOutOfStockFromDOM() {
  // 1. Check the preorder app's own form — if it has a preorder button rendered, trust it
  var preorderForm = document.querySelector('form[id^="product-form-template"]');
  if (preorderForm) {
    var allBtns = preorderForm.querySelectorAll('button, input[type="submit"]');
    for (var bi = 0; bi < allBtns.length; bi++) {
      var btnText = (allBtns[bi].textContent || allBtns[bi].value || '').toLowerCase();
      if (btnText.indexOf('pre-order') !== -1 || btnText.indexOf('preorder') !== -1) {
        return true;
      }
    }
  }

  // 2. Check the theme's native purchase button for sold-out state
  var nativeBtn = document.querySelector(
    '.purchase-details__buttons button[type="submit"], ' +
    '.purchase-details__buttons input[type="submit"], ' +
    '.purchase-details__buttons .add_to_cart'
  );
  if (nativeBtn) {
    var nativeText = (nativeBtn.textContent || nativeBtn.value || '').toLowerCase().trim();
    var soldOutWords = ['sold out', 'out of stock', 'unavailable'];
    for (var wi = 0; wi < soldOutWords.length; wi++) {
      if (nativeText.indexOf(soldOutWords[wi]) !== -1) return true;
    }
    // Button is disabled but not in the middle of an add-to-cart action
    if (
      nativeBtn.disabled &&
      nativeText !== 'adding...' &&
      nativeText !== 'add to cart' &&
      nativeText !== 'add to bag'
    ) {
      return true;
    }
  }

  return false;
}

function hydrateFlipbenchImages(scope) {
  scope.querySelectorAll('.product_gallery img, .product_gallery_nav img').forEach(function (img) {
    if (img.getAttribute('data-src'))    img.setAttribute('src',    img.getAttribute('data-src'));
    if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
    img.classList.remove('lazyload', 'lazyloading');
    img.classList.add('lazyloaded');
  });
}
function syncFlipbenchPaymentTerms() {
  var target    = document.querySelector('#FlipbenchPaymentTermsWrap [data-payment-terms-target]');
  var reference = document.querySelector('#FlipbenchProductForm [data-payment-terms-reference]');

  if (!target) return;

  if (reference && reference.innerHTML.trim()) {
    // Re-inject fresh markup so <shopify-payment-terms> re-upgrades + refetches for the new variant
    target.innerHTML = reference.innerHTML;
    target.style.display = '';
  } else {
    target.innerHTML = '';
    target.style.display = 'none';
  }

  // Nudge Shopify to re-hydrate the dynamic checkout / payment terms element
  try {
    if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
      Shopify.PaymentButton.init();
    }
  } catch (e) {}
}

function showFlipbenchLoader() {
  document.body.classList.add('flipbench-loading');

  if (!document.querySelector('.flipbench-loader')) {
    var loader = document.createElement('div');
    loader.className = 'flipbench-loader';
    loader.innerHTML = '<div class="flipbench-loader__spinner"></div>';
    document.body.appendChild(loader);
  }

  var bundleSelect = document.querySelector('#FlipbenchBundleSelect');
  if (bundleSelect) bundleSelect.disabled = true;
}

function hideFlipbenchLoader() {
  document.body.classList.remove('flipbench-loading');

  var loader = document.querySelector('.flipbench-loader');
  if (loader) loader.remove();

  var bundleSelect = document.querySelector('#FlipbenchBundleSelect');
  if (bundleSelect) bundleSelect.disabled = false;
}

function syncFlipbenchButtonVisibility() {
  var bundleSel = document.querySelector('#FlipbenchBundleSelect');
  if (!bundleSel) return;

  var opt = bundleSel.options[bundleSel.selectedIndex];
  if (!opt) return;

  updateFlipbenchStateFromOption(opt);

  var shouldPreorder = window.flipbenchIsPreorder === true;

  document.body.classList.toggle('flipbench-is-preorder', shouldPreorder);

  var preorderForm  = document.querySelector('form[id^="product-form-template"]');
  var normalButtons = document.querySelector('.purchase-details__buttons');
  var addBtn        = document.querySelector('#FlipbenchAddToCartButton');

  if (shouldPreorder) {
    if (normalButtons) normalButtons.style.setProperty('display', 'none', 'important');
    if (addBtn)        addBtn.style.setProperty('display', 'none', 'important');
    if (preorderForm)  preorderForm.style.setProperty('display', 'flex', 'important');
    return;
  }

  if (preorderForm)  preorderForm.style.setProperty('display', 'none', 'important');
  if (normalButtons) normalButtons.style.removeProperty('display');

  if (addBtn) {
    addBtn.style.removeProperty('display');
    addBtn.disabled = false;
    addBtn.classList.remove('disabled');
    addBtn.setAttribute('aria-disabled', 'false');
  }
}

function forceFlipbenchButtonStatus() {
  syncFlipbenchButtonVisibility();

  setTimeout(syncFlipbenchButtonVisibility, 100);
  setTimeout(syncFlipbenchButtonVisibility, 400);
  setTimeout(syncFlipbenchButtonVisibility, 1000);
  setTimeout(syncFlipbenchButtonVisibility, 1500);
}

/* ================================
   STAMPED REVIEW SYNCHRONIZATION
================================ */

/**
 * Get the review-source product ID defined in product.liquid.
 *
 * For product 8279308992627, this returns 7629052510323.
 * For other products, it returns their own product ID.
 */
function getFlipbenchStampedReviewSourceId() {
  var reviewsWrap = document.querySelector('#FlipbenchReviewsWrap');

  if (!reviewsWrap) return '';

  var sourceId = reviewsWrap.getAttribute(
    'data-stamped-review-source-id'
  );

  if (sourceId) {
    return String(sourceId);
  }

  /*
   * Fallback to the rating badge data-id.
   */
  var reviewBadge = reviewsWrap.querySelector(
    '.stamped-product-reviews-badge'
  );

  if (reviewBadge) {
    return String(reviewBadge.getAttribute('data-id') || '');
  }

  return '';
}

/**
 * Apply the mapped review-source ID to the original Stamped app block.
 *
 * @param {Boolean} reloadWidget
 * Whether the full Stamped widget should be reloaded.
 *
 * @returns {Boolean}
 */
function syncFlipbenchStampedMainWidget(reloadWidget) {
  var sourceProductId = getFlipbenchStampedReviewSourceId();

  if (!sourceProductId) return false;

  var mainWidget = document.querySelector(
    '#stamped-main-widget, ' +
    '[data-widget-type="main"], ' +
    '[data-stamped-widget-type="main"], ' +
    '.stamped-reviews-widget'
  );

  if (!mainWidget) return false;

  /*
   * The standard Stamped Main Widget reads data-product-id.
   */
  mainWidget.setAttribute(
    'data-product-id',
    sourceProductId
  );

  /*
   * Some Stamped widget versions also include data-id.
   * Update it only when it already exists.
   */
  if (mainWidget.hasAttribute('data-id')) {
    mainWidget.setAttribute(
      'data-id',
      sourceProductId
    );
  }

  if (reloadWidget !== true) {
    return true;
  }

  /*
   * Do not reload the same mapped product repeatedly.
   */
  var alreadyLoadedId = mainWidget.getAttribute(
    'data-flipbench-loaded-review-id'
  );

  if (
    alreadyLoadedId === sourceProductId &&
    mainWidget.innerHTML.trim() !== ''
  ) {
    try {
      if (
        window.StampedFn &&
        typeof window.StampedFn.loadBadges === 'function'
      ) {
        window.StampedFn.loadBadges();
      }
    } catch (error) {
      console.warn(
        'Stamped badge reload error:',
        error
      );
    }

    return true;
  }

  /*
   * Stamped may not have loaded yet.
   * The delayed calls in DOMContentLoaded will retry.
   */
  if (!window.StampedFn) {
    return true;
  }

  mainWidget.innerHTML = '';

  try {
    if (typeof window.StampedFn.init === 'function') {
      window.StampedFn.init();
    }

    if (typeof window.StampedFn.reloadUGC === 'function') {
      window.StampedFn.reloadUGC();
    }

    if (typeof window.StampedFn.loadBadges === 'function') {
      window.StampedFn.loadBadges();
    }

    mainWidget.setAttribute(
      'data-flipbench-loaded-review-id',
      sourceProductId
    );
  } catch (error) {
    console.warn(
      'Stamped main widget reload error:',
      error
    );
  }

  return true;
}


// Close Button
// (function () {
//   function makeCloseBtn() {
//     if (document.getElementById('fb-custom-close')) return;
//     var btn = document.createElement('button');
//     btn.id = 'fb-custom-close';
//     btn.innerHTML = '&times;';
//     btn.setAttribute('aria-label', 'Close');
//     document.body.appendChild(btn);

//     btn.addEventListener('click', function () {
//       // Try known lightbox close mechanisms
//       var closed = false;

//       // Fancybox v3/v4
//       if (window.Fancybox && typeof window.Fancybox.close === 'function') {
//         window.Fancybox.close(); closed = true;
//       }
//       if (!closed && window.jQuery && window.jQuery.fancybox) {
//         window.jQuery.fancybox.close(); closed = true;
//       }
//       // PhotoSwipe / theme modal — click its native close if present
//       if (!closed) {
//         var native = document.querySelector(
//           '.fancybox-button--close, .pswp__button--close, .modal__close, [data-fancybox-close]'
//         );
//         if (native) { native.click(); closed = true; }
//       }
//       // Last resort: ESC key
//       if (!closed) {
//         document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27 }));
//       }
//       hideBtn();
//     });
//   }

//   function showBtn() { var b = document.getElementById('fb-custom-close'); if (b) b.style.display = 'flex'; }
//   function hideBtn() { var b = document.getElementById('fb-custom-close'); if (b) b.style.display = 'none'; }

//   // Detect when a lightbox opens by watching the body/DOM
//   var observer = new MutationObserver(function () {
//     var open = document.querySelector(
//       '.fancybox__container, .fancybox-container, .pswp--open, .pswp.pswp--visible, .modal.is-active, .js-gallery-modal.is-open'
//     );
//     if (open) { makeCloseBtn(); showBtn(); } else { hideBtn(); }
//   });

//   document.addEventListener('DOMContentLoaded', function () {
//     makeCloseBtn(); hideBtn();
//     observer.observe(document.body, { childList: true, subtree: true, attributes: true });
//   });
// })();